import { CONFIG } from '../../core/config';
import { EquipmentFunctionModelSelectionCriteriaBase } from './equipment-function-model-selection-criteria-base';
import { FailureRateSearchResult } from './failure-rate-search-result';
import { SelectedFailureMode } from './selected-failure-mode';

export class FailureRateSelectionCriteria extends EquipmentFunctionModelSelectionCriteriaBase {
  readonly friendlyTypeNameSingular: string = 'Failure Rate Selection Criteria';
  readonly apiRoute: string = CONFIG.apiRoutes.failureRateSelectionCriteria;

  id: string;
  searchResult: FailureRateSearchResult = new FailureRateSearchResult();
  industryId: string;
  selectedFailureModes: SelectedFailureMode[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    super.loadFromJson(data);

    this.id = data.Id;
    this.industryId = data.industryId;

    if (data.selectedFailureModes) {
      this.selectedFailureModes = data.selectedFailureModes;
    }

    this.searchResult = new FailureRateSearchResult();
    if (data.searchResult) {
      this.searchResult.loadFromJson(data.searchResult);
    }
  }

  hasModel(): boolean {
    return this.searchResult && this.searchResult.foundFailureRates.length > 0;
  }

  modelName(): string {
    return '';
  }
}
